import {
  cepFix,
  cnaeMask,
  cnpjFix,
  currencyFormatWithCents,
  mask,
  unMask,
} from 'utils/mask';
import { FormPropsPJType } from '../types/FormPropType/FormPropPJType';
import { map } from 'lodash';

export function initialData(
  person: any,
  enderecoIndex: any,
  phone: any,
  getEmail: () => string
): FormPropsPJType {
  const initialData = {
    id: person?.id,
    nome: person?.nome ?? '',
    nomeFantasia: person?.nomeFantasia ?? '',
    cnpj: mask(cnpjFix(person?.cnpj), '##.###.###/####-##'),
    dataFundacaoEmpresa: person?.dataFundacaoEmpresa ?? '',
    inscricaoEstadual: person?.inscricaoEstadual ?? '',
    ramoAtividade: person?.dadosFinanceira?.ramoAtividade ?? '',
    faturamentoAnual: currencyFormatWithCents(
      person?.dadosFinanceira?.valorFaturamento ?? 0
    ),
    tipoEmpresa: `${person?.tipoEmpresa}`,
    classeEconomica: `${person?.dadosFinanceira?.classeEconomicaSetor}`,
    atividadePrincipal: undefined,
    porteEmpresa: `${person?.dadosFinanceira?.porteEmpresa}`,
    cnae: person?.dadosFinanceira?.cnae
      ? String(person.dadosFinanceira.cnae).padStart(7, '0')
      : '',

    email: getEmail(),
    telefone: phone ? phone.ddd + phone.telefone : '',

    cep:
      enderecoIndex >= 0 && person?.enderecos?.[enderecoIndex]?.cep
        ? cepFix(person?.enderecos?.[enderecoIndex]?.cep)
        : '',

    logradouro:
      enderecoIndex >= 0 && person?.enderecos?.[enderecoIndex]?.endereco
        ? person?.enderecos?.[enderecoIndex]?.endereco
        : '',

    numero:
      enderecoIndex >= 0 && person?.enderecos?.[enderecoIndex]?.numero
        ? person?.enderecos?.[enderecoIndex]?.numero.toString()
        : '',

    complemento:
      enderecoIndex >= 0 && person?.enderecos?.[enderecoIndex]?.complemento
        ? person?.enderecos?.[enderecoIndex]?.complemento
        : '',

    bairro:
      enderecoIndex >= 0 && person?.enderecos?.[enderecoIndex]?.bairro
        ? person?.enderecos?.[enderecoIndex]?.bairro
        : '',
    cidade:
      enderecoIndex >= 0 && person?.enderecos?.[enderecoIndex]?.nomeMunicipio
        ? person?.enderecos?.[enderecoIndex]?.nomeMunicipio
        : '',

    uf:
      enderecoIndex >= 0 && person?.enderecos?.[enderecoIndex]?.codigoEstado
        ? person?.enderecos?.[enderecoIndex]?.codigoEstado
        : '',

    tipoLogradouro:
      enderecoIndex >= 0 && person?.enderecos?.[enderecoIndex]?.tipoLogradouro
        ? person?.enderecos?.[enderecoIndex]?.tipoLogradouro
        : '',

    observacoes: person?.pessoaRendas?.[0]?.observacao ?? '',

    socios: map(person?.socios, (socio) => ({
      pessoaSocioId: socio.pessoaSocioId,
      cpfCnpj: socio.cpfCnpj,
      nome: socio.nome,
      percentualSocietario: socio.percentualSocietario
        ? socio.percentualSocietario
        : socio.percentualSocietario,
    })),

    avalista: undefined,
  };

  return initialData;
}
